// extracted by mini-css-extract-plugin
module.exports = {"table":"ResultTable_table__D4naT","header":"ResultTable_header__3elfa","name":"ResultTable_name__3qzu1","result":"ResultTable_result__3FF6A","normal":"ResultTable_normal__14NXG"};